















import Vue, { PropType } from "vue"
import { IconType } from "~/config/icon"

export default Vue.extend({
  props: {
    iconType: {
      type: String as PropType<IconType>,
      default: null,
    },
    isLightColorIcon: {
      type: Boolean,
      default: false,
    },
    isWithoutIconOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisibleIcon(): boolean {
      return (
        this.iconType !== null &&
        (!this.isWithoutIconOnMobile || !this.$device.isMobile)
      )
    },
  },
})
